import { cn } from "../../utils/classNames";

const glowClasses = {
  purple: "shadow-glow",
  gold: "shadow-gold",
  neon: "shadow-neon",
  none: "",
};

export default function Card({
  as: Component = "section",
  className = "",
  children,
  glow = "none",
  interactive = false,
  ...props
}) {
  return (
    <Component
      className={cn(
        "rounded-hookd border border-hookd-line bg-hookd-panel text-hookd-cream shadow-panel",
        interactive && "transition duration-200 hover:border-hookd-empress/70 hover:shadow-glow",
        glowClasses[glow] || "",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
